module.exports = __webpack_public_path__ + "static/image/history/pc/201501@3x.jpg?4305ff72";